import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { Text, TextType } from 'ui-components/components/text';
import generalStyles from '../../../../style.module.css';
import { InventoryWarehousePropType } from '../prop-types/inventory-warehouse';
import { messages } from './messages';
import style from './style.module.css';

export const WarehousePicker = ({ inventoryWarehouses, selectedWarehouseId, setSelectedWarehouseId }) => {
  const intl = useIntl();
  const selectedWarehouse = inventoryWarehouses.find((wrh) => wrh.inventoryWarehouseId === selectedWarehouseId);
  const selectorText = selectedWarehouse ? (
    <span>{selectedWarehouse.name}</span>
  ) : (
    <FormattedMessage {...messages.addToLocationSelectWarehouse} />
  );
  return (
    <div className={style['input-wrapper']}>
      <Text textType={TextType.Label} value={messages.addToLocationWarehouse} />
      <div>
        <DropdownMenu dropdownMenuShouldHaveWidthOfButton fullWidth variant='form'>
          <DropdownMenuToggler className={generalStyles['toggler-text']} title={selectorText}>
            {selectorText}
          </DropdownMenuToggler>
          <DropdownMenuItem key='' onClick={() => setSelectedWarehouseId(undefined)}>
            {intl.formatMessage(messages.addToLocationSelectWarehouse)}
          </DropdownMenuItem>
          {inventoryWarehouses.map((warehouse) => (
            <DropdownMenuItem key={warehouse.inventoryWarehouseId} onClick={() => setSelectedWarehouseId(warehouse.inventoryWarehouseId)}>
              {warehouse.name}
            </DropdownMenuItem>
          ))}
        </DropdownMenu>
      </div>
    </div>
  );
};

WarehousePicker.propTypes = {
  inventoryWarehouses: PropTypes.arrayOf(InventoryWarehousePropType).isRequired,
  selectedWarehouseId: PropTypes.number,
  setSelectedWarehouseId: PropTypes.func.isRequired,
};
